import reducer from 'reducer';
import {
  applyMiddleware,
  compose,
  legacy_createStore as createStore,
} from 'redux';
import { thunk } from 'redux-thunk';
import { composeWithDevTools } from '@redux-devtools/extension';
import { env_type } from 'env';

let store = {};
export const configureStore = () => {
  const composeEnhancers =
    env_type === 'production'
      ? compose
      : composeWithDevTools({
          // other compose enhancers if any
          // Specify here other options if needed
        });

  // Setting middlewares
  const middlewares = [thunk];
  store = createStore(
    reducer,
    composeEnhancers(applyMiddleware(...middlewares))
  );

  if (import.meta.hot) {
    import.meta.hot.accept('../reducer', (module) => {
      if (module) store.replaceReducer(module.default);
    });
  }

  return store;
};

export function getStore() {
  return store;
}
